export default "__VITE_PUBLIC_ASSET__3b50a65b__"